import { TeacherService } from './../teacher.service';
import { Component, OnInit , NgZone} from '@angular/core';
import { GoogleSheetScoreService } from './../GoogleSheetScore.service';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import * as CanvasJS from '../../assets/canvasjs.min.js';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);
@Component({
  selector: 'app-teacher-home',
  templateUrl: './teacher-home.component.html',
  styleUrls: ['./teacher-home.component.css']
})
export class TeacherHomeComponent implements OnInit {
  private chart: am4charts.XYChart;
  private chart2: am4charts.PieChart;
  private chart3: am4charts.XYChart;
  private chart4: am4charts.XYChart;
  private chart5: am4charts.RadarChart;
  students;
  SchoolStat;
  activities;
  homeworks;
  fullhomeworks;
  mcRecords;
  hwemail;
  loading = false;
  constructor(
    private GoogleSheetScoreService: GoogleSheetScoreService,
    private teacherService: TeacherService,
    private zone: NgZone
  ) { }

  getHW(email){
    try{
      this.homeworks = this.GoogleSheetScoreService.getScore(false,email);      
      this.fullhomeworks = this.GoogleSheetScoreService.getFullScore(true,email);	
        
    } catch{
      this.homeworks = ""
      this.fullhomeworks = ""
    }
    
    

  }

  getChart(data){
    console.log(data)
    
    let chart = new CanvasJS.Chart("chartContainer", {
      animationEnabled: true,
      theme: "light2",
      title:{
        text: "School Usage"
      },
      axisY:{
        includeZero: false
      },
      data: [{        
        type: "line",       
        dataPoints: data
      }]
    });
      
    chart.render();
    }
  ngOnInit() {
    
    console.log("Init Teacher Panel")
    this.students = this.teacherService.getStudentDetails();
    this.SchoolStat = this.teacherService.getSchoolMCStat();
    this.activities = this.teacherService.getStudentMCActivities();

    var xhr = new XMLHttpRequest();        
    
   xhr.open('GET', 'https://api.studydse.net/api/get_school_mc_stat_chart.php');
   xhr.withCredentials = true;
	// xhr.open('GET', '/assets/chart.json');
	 xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	 xhr.onload = () => {
		this.getChart(JSON.parse(xhr.responseText));

		   
	 };
   xhr.send();
   
  }


  loadChart(reload) {
    if (reload){
      this.chart.dispose();
    }
    if((!this.chart || reload) && !this.loading){

      console.log("Loading...")
      this.loading = true;
    this.zone.runOutsideAngular(() => {


      var xhr = new XMLHttpRequest();        
    
      xhr.open('GET', 'https://api.studydse.net/api/get_topicVSHK.php');
      xhr.withCredentials = true;
     // xhr.open('GET', '/assets/chart.json');
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.onload = () => {
       let data = JSON.parse(xhr.responseText);
       let chart = am4core.create("chartContainer2", am4charts.XYChart);

       var title = chart.titles.push(new am4core.Label());
        title.text = "Chart of difference (Your School vs Hong Kong)";
        title.fontSize = 25;
        title.marginBottom = 25;
        
        // Add data
        chart.data = data;        
        
        // Create axes
        var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "category";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.inversed = true;
        categoryAxis.renderer.minGridDistance = 20;
        categoryAxis.renderer.axisFills.template.disabled = false;
        categoryAxis.renderer.axisFills.template.fillOpacity = 0.05;
        
        
        var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
        valueAxis.min = -30;
        valueAxis.max = 30;
        valueAxis.renderer.minGridDistance = 50;
        valueAxis.renderer.ticks.template.length = 10;
        valueAxis.renderer.ticks.template.disabled = false;
        valueAxis.renderer.ticks.template.strokeOpacity = 0.4;
        valueAxis.renderer.labels.template.adapter.add("text", function(text) {
          return text == "Male" || text == "Female" ? text : text + "%";
        })
        
        // Legend
        chart.legend = new am4charts.Legend();
        chart.legend.position = "right";
        chart.legend.width = 100;
        
        // Use only absolute numbers
        chart.numberFormatter.numberFormat = "#.#s";
        
        // Create series
        function createSeries(field, name, color) {
          var series = chart.series.push(new am4charts.ColumnSeries());
          series.dataFields.valueX = field;
          series.dataFields.categoryY = "category";
          series.stacked = true;
          series.name = name;
          series.stroke = color;
          series.fill = color;
          
          var label = series.bullets.push(new am4charts.LabelBullet);
          label.label.text = "{valueX}%";
          label.label.fill = am4core.color("#fff");
          label.label.strokeWidth = 0;
          label.label.truncate = false;
          label.label.hideOversized = true;
          label.locationX = 0.5;
          return series;
        }
        
        var interfaceColors = new am4core.InterfaceColorSet();
        var positiveColor = interfaceColors.getFor("positive");
        var negativeColor = interfaceColors.getFor("negative");
        
        createSeries("negative", "Poor than HK", negativeColor);
        createSeries("positive", "Better than HK", positiveColor);
 
       this.chart = chart;
       this.loading = false;
      };
      xhr.send();


      

    });
    
  }
  }
  
  loadChart2(reload) {
    if (reload){
      this.chart2.dispose();
    }
    if((!this.chart2 || reload) && !this.loading){

      console.log("Loading...")
      this.loading = true;
    this.zone.runOutsideAngular(() => {


      var xhr = new XMLHttpRequest();        
    
      xhr.open('GET', 'https://api.studydse.net/api/get_topicVSHK.php');
      xhr.withCredentials = true;
     // xhr.open('GET', '/assets/chart.json');
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.onload = () => {
        var chart = am4core.create("chartContainer3", am4charts.PieChart);
        var title = chart.titles.push(new am4core.Label());
                title.text = "Topic Distribution";
                title.fontSize = 25;
                title.marginBottom = 25;
        // Add data
        chart.data = [
          {"tag":"ch02","count":"65","id":"1","name":"Ch02 Cells and Molecules of Life","cname":"Ch02 生命的基本單位"},
          {"tag":"ch03","count":"30","id":"21","name":"Ch03 Movement of substances across cell membrane","cname":"Ch03 物質穿越細胞膜的活動\r\n"},
          {"tag":"ch04","count":"23","id":"22","name":"Ch04 Enzymes and metabolism\r\n","cname":"Ch04 酶和新陳代謝\r\n"},
          {"tag":"ch05","count":"64","id":"2","name":"Ch05 Food and humans","cname":"Ch05 食物和人類"},
          {"tag":"ch06","count":"91","id":"3","name":"Ch06 Nutrition in humans","cname":"Ch06 人的營養"},
          {"tag":"ch07","count":"51","id":"4","name":"Ch07 Gas Exchange in Humans","cname":"Ch07 人體的氣體交換"},
          {"tag":"ch08","count":"87","id":"5","name":"Ch08 Transport in Humans","cname":"Ch08 人體內物質的轉運"},
          {"tag":"ch09","count":"83","id":"6","name":"Ch09 Obtaining essentials for life in green plants","cname":"Ch09 植物的營養和氣體交換"},
          {"tag":"ch10","count":"24","id":"23","name":"Ch10 Transpiration, transport and support in plants\r\n","cname":"Ch10 植物的蒸騰、轉運和支持"},
          {"tag":"ch11","count":"27","id":"7","name":"Ch11 Cell Cycle and Division ","cname":"Ch11 細胞週期和分裂"},
          {"tag":"ch12","count":"134","id":"8","name":"Ch12 Reproduction","cname":"Ch12 有花植物的生殖"},
          {"tag":"ch13","count":"16","id":"26","name":"Ch13 Reproduction in humans\r\n","cname":"Ch13 人的生殖\r\n"},
          {"tag":"ch14","count":"39","id":"9","name":"Ch14 Growth and development","cname":"Ch14 生長和發育"},
          {"tag":"ch15","count":"96","id":"10","name":"Ch15 Detecting the environment","cname":"Ch15 環境狀況的探測"},
          {"tag":"ch16","count":"46","id":"11","name":"Ch16 Coordination in humans","cname":"Ch16 人體的協調"},
          {"tag":"ch17","count":"60","id":"12","name":"Ch17 Movement in Humans","cname":"Ch17 人體的運動 "},
          {"tag":"ch19","count":"55","id":"13","name":"Ch19 Biodiversity","cname":"Ch19 生物多樣性 "},
          {"tag":"ch20","count":"118","id":"14","name":"Ch20 The Ecosystem","cname":"Ch20 生態系"},
          {"tag":"ch21","count":"49","id":"15","name":"Ch21 Photosynthesis","cname":"Ch21 光合作用"},
          {"tag":"ch22","count":"51","id":"16","name":"Ch22 Respiration ","cname":"Ch22 呼吸作用"},
          {"tag":"ch23","count":"30","id":"17","name":"Ch23 Health and Diseases","cname":"Ch23 傳染病\r\n"},
          {"tag":"ch24","count":"2","id":"24","name":"Ch24 Non-infectious diseases and disease prevention","cname":"Ch24 非傳染病和疾病的預防\r\n"},
          {"tag":"ch25","count":"9","id":"25","name":"Ch25 Body defence mechanisms","cname":"Ch25 身體的防禦機制\r\n"},
          {"tag":"ch27","count":"9","id":"18","name":"Ch27 Basic Genetics","cname":"Ch27 分子遺傳學"},
          {"tag":"ch29","count":"6","id":"19","name":"Ch29 Molecular and Applied Genetics","cname":"Ch29 生物工程"},
          {"tag":"ch30","count":"10","id":"20","name":"Ch30 Evolution","cname":"Ch30 進化"}
          ];
        
        // Set inner radius
        chart.innerRadius = am4core.percent(50);
        
        // Add and configure Series
        var pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "count";
        pieSeries.dataFields.category = "name";
        pieSeries.slices.template.stroke = am4core.color("#fff");
        pieSeries.slices.template.strokeWidth = 2;
        pieSeries.slices.template.strokeOpacity = 1;
        
        // This creates initial animation
        pieSeries.hiddenState.properties.opacity = 1;
        pieSeries.hiddenState.properties.endAngle = -90;
        pieSeries.hiddenState.properties.startAngle = -90;
        
       
       this.chart2 = chart;
       this.loading = false;
      };
      xhr.send();


      

    });
    
  }
  }


  loadChart3(reload) {
    if (reload){
      this.chart3.dispose();
    }
    if((!this.chart3 || reload) && !this.loading){

      console.log("Loading3...")
      this.loading = true;
    this.zone.runOutsideAngular(() => {


      var xhr = new XMLHttpRequest();        
    
      xhr.open('GET', 'https://api.studydse.net/api/get_school_mc_stat_chart.php');
      xhr.withCredentials = true;
     // xhr.open('GET', '/assets/chart.json');
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.onload = () => {
        console.log("Done...")
       let data = JSON.parse(xhr.responseText);
       var chart = am4core.create("chartContainer4", am4charts.XYChart);

      var title = chart.titles.push(new am4core.Label());
              title.text = "MC Exercises Usage";
              title.fontSize = 25;
              title.marginBottom = 25;
      // Add data
      chart.data = data;
        
        // Create axes
        var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        //dateAxis.renderer.grid.template.location = 0;
        //dateAxis.renderer.minGridDistance = 30;
        
        var valueAxis1 = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis1.title.text = "No. of Students";
        
        var valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis2.title.text = "No. of Exercises";
        valueAxis2.renderer.opposite = true;
        valueAxis2.renderer.grid.template.disabled = true;
        
        // Create series
        var series1 = chart.series.push(new am4charts.ColumnSeries());
        series1.dataFields.valueY = "student";
        series1.dataFields.dateX = "date";
        series1.yAxis = valueAxis1;
        series1.name = "No. of Students";
        series1.tooltipText = "{name}\n[bold font-size: 20]{valueY}[/]";
        series1.fill = chart.colors.getIndex(0);
        series1.strokeWidth = 0;
        series1.clustered = false;
        series1.columns.template.width = am4core.percent(40);
        
        
        
        var series3 = chart.series.push(new am4charts.LineSeries());
        series3.dataFields.valueY = "exercise";
        series3.dataFields.dateX = "date";
        series3.name = "No. of Exercises";
        series3.strokeWidth = 2;
        series3.tensionX = 0.7;
        series3.yAxis = valueAxis2;
        series3.tooltipText = "{name}\n[bold font-size: 20]{valueY}[/]";
        
        var bullet3 = series3.bullets.push(new am4charts.CircleBullet());
        bullet3.circle.radius = 3;
        bullet3.circle.strokeWidth = 2;
        bullet3.circle.fill = am4core.color("#fff");
        
        
        
        // Add cursor
        chart.cursor = new am4charts.XYCursor();
        
        // Add legend
        chart.legend = new am4charts.Legend();
        chart.legend.position = "top";
 
       this.chart3 = chart;
       this.loading = false;
      };
      xhr.send();


      

    });
    
  }
  }

  loadChart4(reload,googleID) {
		try{
		  this.chart4.dispose();
    }
    catch{
      console.log("Can't Dispose!")
    }
    finally{    
		  console.log("Loading Chart of Google ID "+googleID)
		  this.loading = true;
		this.zone.runOutsideAngular(() => {	
		  var xhr = new XMLHttpRequest();        
		
      xhr.open('GET', 'https://api.studydse.net/api/get_topic_correct_chart.php?googleID='+googleID);
      xhr.withCredentials = true;
		 // xhr.open('GET', '/assets/chart.json');
		  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		  xhr.onload = () => {
		   let data = JSON.parse(xhr.responseText);
		   var chart = am4core.create("chartContainer6-"+googleID, am4charts.XYChart);

var title = chart.titles.push(new am4core.Label());
					title.text = "Performance on All Topics";
					title.fontSize = 25;
					title.marginBottom = 25;

			
			var value = 120;


			chart.data =data;
			var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
			categoryAxis.renderer.grid.template.location = 0;
			categoryAxis.dataFields.category = "tag";
			categoryAxis.renderer.minGridDistance = 15;
			categoryAxis.renderer.grid.template.location = 0.5;
			categoryAxis.renderer.grid.template.strokeDasharray = "1,3";
			categoryAxis.renderer.labels.template.rotation = -90;
			categoryAxis.renderer.labels.template.horizontalCenter = "left";
			categoryAxis.renderer.labels.template.location = 0.5;

			categoryAxis.renderer.labels.template.adapter.add("dx", function(dx, target) {
				return -target.maxRight / 2;
			})

			var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
			valueAxis.tooltip.disabled = true;
			valueAxis.renderer.ticks.template.disabled = true;
			valueAxis.renderer.axisFills.template.disabled = true;
			valueAxis.title.text = "No. of Correct Answer / Exercises";
			var series = chart.series.push(new am4charts.ColumnSeries());
			series.dataFields.categoryX = "tag";
			series.dataFields.valueY = "score";
			series.name = "No. of Correct Answers";
			series.tooltipText = "{valueY.score}";
			series.sequencedInterpolation = true;
			series.fillOpacity = 0;
			series.strokeOpacity = 1;
			
			series.columns.template.width = 0.01;
			series.tooltip.pointerOrientation = "horizontal";

			var series2 = chart.series.push(new am4charts.ColumnSeries());
			series2.dataFields.categoryX = "tag";
			series2.dataFields.valueY = "times";
			series2.name = "No. of Exercises";
			series2.tooltipText = "{valueY.times}";
			series2.sequencedInterpolation = true;
			series2.fillOpacity = 0;
			series2.strokeOpacity = 1;
			
			series2.columns.template.width = 0.01;
			series2.tooltip.pointerOrientation = "horizontal";

			var bullet = series.bullets.create(am4charts.CircleBullet);
			var bullet2 = series2.bullets.create(am4charts.CircleBullet);
			chart.cursor = new am4charts.XYCursor();

			chart.scrollbarX = new am4core.Scrollbar();
			chart.scrollbarY = new am4core.Scrollbar();
			chart.legend = new am4charts.Legend();
	 
		   this.chart4 = chart;
		   this.loading = false;
		  };
		  xhr.send();
	
	
		  
	
		});
		
	  }
	  }


    loadChart5(reload,googleID) {
      try{
        this.chart5.dispose();
      }
      catch{
        console.log("Can't Dispose!")
      }
      finally{    
        console.log("Loading Radar Chart of Google ID "+googleID)
     
		  this.loading = true;
		this.zone.runOutsideAngular(() => {	
		  var xhr = new XMLHttpRequest();        
		
      xhr.open('GET', 'https://api.studydse.net/api/get_student_radar_chart.php?googleID='+googleID);
      xhr.withCredentials = true;
		 // xhr.open('GET', '/assets/chart.json');
		  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		  xhr.onload = () => {
		   let data = JSON.parse(xhr.responseText);
		   var chart = am4core.create("chartContainer7-"+googleID, am4charts.RadarChart);

			var title = chart.titles.push(new am4core.Label());
					title.text = "Performance on DSE Topic";
					title.fontSize = 25;
					title.marginBottom = 25;

			/* Add data */
			chart.data = data;

			/* Create axes */
			var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis() as any);
			categoryAxis.dataFields.category = "tag";

			var valueAxis = chart.yAxes.push(new am4charts.ValueAxis() as any);
			valueAxis.renderer.axisFills.template.fill = chart.colors.getIndex(2);
			valueAxis.renderer.axisFills.template.fillOpacity = 0.05;

			/* Create and configure series */
			var series = chart.series.push(new am4charts.RadarSeries());
			series.dataFields.valueY = "school_rate";
			series.dataFields.categoryX = "tag";
			series.name = "School Correct Rate";
			series.strokeWidth = 3;
			series.bullets.create(am4charts.CircleBullet);
			series.tooltipText = "School: {valueY}%";


			var series2 = chart.series.push(new am4charts.RadarSeries());
			series2.dataFields.valueY = "student_rate";
			series2.dataFields.categoryX = "tag";
			series2.name = "Student Correct Rate";
			series2.strokeWidth = 3;
			series2.bullets.create(am4charts.CircleBullet);
			series2.tooltipText = "You: {valueY}%";

			var series3 = chart.series.push(new am4charts.RadarSeries());
			series3.dataFields.valueY = "hk_rate";
			series3.dataFields.categoryX = "tag";
			series3.name = "HK Correct Rate";
			series3.strokeWidth = 3;
			series3.bullets.create(am4charts.CircleBullet);
			series3.tooltipText = "HK: {valueY}%";


			chart.cursor = new am4charts.RadarCursor();

			chart.legend = new am4charts.Legend();
	      
         this.chart5 = chart;
         this.loading = false;
        };
        xhr.send();
    
    
        
    
      });
      
      }
      }

      mcdetails(googleID){
        try{
          this.mcRecords = [];
        }
        finally{
          console.log("Loading MC Details...")
          var xhr = new XMLHttpRequest();        		
          xhr.open('GET', 'https://api.studydse.net/api/get_mc_record.php?googleID='+googleID);
          xhr.withCredentials = true;
          xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
          xhr.onload = () => {
            
           //this.mcRecords = JSON.parse(xhr.responseText);
           this.mcRecords = JSON.parse(xhr.responseText);
     
          }
          xhr.send();
        }
       
        
      }
  ngOnDestroy() {
    this.zone.runOutsideAngular(() => {
      if (this.chart) {
        this.chart.dispose();
      }
      if (this.chart2) {
        this.chart2.dispose();
      }
      if (this.chart3) {
        this.chart3.dispose();
      }
      if (this.chart4) {
        this.chart3.dispose();
      }
      if (this.chart5) {
        this.chart5.dispose();
      }
    });
  }

}
